import { tripResponseEntity } from "../../Data/Connections/Trip"
import type { DataStore } from "../../Data/Store"
import type { IAppResponse, ITripResponse } from "../../Types"
import { TripApi } from "../../Types/Generated/LogbookApi/TripApi"
import type { ITripUpdateRequest } from "../../Types/Generated/LogbookApi/TripApi"

export interface TripWriterIds {
  shipId: number;
  tripId: number;
}

export interface TripWriters {
  updateTrip: (values: ITripUpdateRequest) => Promise<ITripResponse>;
  calculateTrip: () => Promise<IAppResponse>;
}

export function createStoreTripWriters(store: DataStore, ids: TripWriterIds): TripWriters {
  return {
    updateTrip: (values) => {
      const current = store.getEntity("Trip", ids.tripId);
      const optimistic = current ? { ...current, ...values } : undefined;
      return store.mutate({
        optimistic: optimistic ? { upsert: { Trip: [optimistic] } } : undefined,
        request: (client) => new TripApi(client).trips.update({ params: ids, body: values }).call(),
        reconcile: (response) => {
          const latest = store.getEntity("Trip", ids.tripId);
          return {
            entities: {
              Trip: optimistic && latest !== optimistic
                ? []
                : [tripResponseEntity(response, latest)],
            },
          };
        },
      });
    },
    calculateTrip: () => store.mutate({
      request: (client) => new TripApi(client).trips.calculate({ params: ids }).call(),
    }),
  };
}

const rejectNoop = (name: string) => (): Promise<never> =>
  Promise.reject(new Error(`noopTripWriters.${name}: no writer provided (read-only Trip context)`));

export const noopTripWriters: TripWriters = {
  updateTrip: rejectNoop("updateTrip"),
  calculateTrip: rejectNoop("calculateTrip"),
};
